/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum AppModules {
    ADMIN = 'Admin',
    MY_OFERTEO ='CustomerView',
    PUBLIC = 'PublicView',
    LOGIN_REGISTER = 'LoginRegister',
    BUYER_VIEW = 'BuyerView',
}
